import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-create-team',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './create-team.component.html',
  styleUrls: ['./create-team.component.scss'],
})
export class CreateTeamComponent {
  teamName: string = '';
  message: string = '';

  constructor(private http: HttpClient) {}

  createTeam() {
    if (!this.teamName.trim()) {
      this.message = 'Inserisci un nome valido per il team.';
      return;
    }
    this.http.post('api/v1/teams/create', { name: this.teamName }).subscribe({
      next: () => {
        this.message = 'Team creato con successo!';
        this.teamName = '';
      },
      error: () => {
        this.message = 'Errore nella creazione del team.';
      }
    });
  }
}